import { useContext } from "react";
import { CreateActionContext } from "./CreateActionContext";

function useInitialize() {
  const { setElement, setShowModal } = useContext(CreateActionContext);
  return (formDefaultValues: any) => {
    setElement(formDefaultValues);
    setShowModal(true);
  };
}

export default useInitialize;
